import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class GeneralEnquiryService {
  constructor(private http: HttpUtilService) {}

  searchCheque(searchOption: number, searchText: string): Observable<any> {
    const option = searchOption;
    const text = encodeURIComponent((searchText ?? "").toString().trim());
    return this.http.get(
      `ChequeIssueService.asmx/SearchCheque?searchOption=${option}&searchText=%22${text}%22`
    );
  }
}
